/**
 * Mittis — koon suositus omilla mitoilla / size recommender
 * Papu Design. Ei riippuvuuksia, toimii kaikissa teemoissa.
 *
 * Käyttö: <mittis-widget data-chart-key="..." data-charts-url="..." data-lang="fi">
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'papu:mittis:body';

  var I18N = {
    fi: {
      title: 'Löydä oma kokosi',
      intro: 'Anna omat mittasi senttimetreinä, niin kerromme mikä koko istuu sinulle parhaiten tässä tuotteessa.',
      optional: 'valinnainen',
      submit: 'Laske sopiva koko',
      recalc: 'Laske uudelleen',
      reset: 'Tyhjennä',
      guideShow: 'Näytä mittapiirros',
      guideHide: 'Piilota mittapiirros',
      close: 'Sulje',
      cm: 'cm',
      needPrimary: 'Anna vähintään: {m}.',
      invalid: '{m}: tarkista mitta (10–250 cm).',
      resultTitle: 'Suosittelemme kokoa',
      betweenTitle: 'Olet kokojen {a} ja {b} rajalla',
      betweenText: 'Mittasi osuvat kokojen väliin. Valitse {a}, jos haluat istuvamman ryhdin, tai {b}, jos pidät väljemmästä.',
      posMiddle: 'osuu tämän koon keskelle — istuvuus on juuri sitä mitä on tarkoitettu.',
      posLoose: 'on tämän koon väljemmässä päässä.',
      posSnug: 'on tämän koon istuvammassa päässä.',
      bumped: 'Nostimme suosituksen kokoon {s}, koska {m} ei mahdu pienempään kokoon.',
      aboveRange: 'Mittasi on suurempi kuin taulukon suurin koko, joten {s} voi tuntua napakalta.',
      belowRange: 'Mittasi on pienempi kuin taulukon pienin koko, joten {s} istuu väljästi.',
      tightWarn: '{m} on tässä koossa tiukka.',
      infoLong: '{m}: vaatteessa {g} cm, sinulla {b} cm — reilusti mittaa.',
      infoShort: '{m}: vaatteessa {g} cm, sinulla {b} cm — voi jäädä hieman lyhyeksi.',
      infoOk: '{m}: vaatteessa {g} cm, sinulla {b} cm — sopiva.',
      garmentTitle: 'Vaatteen mitat koossa {s}',
      yourValue: 'Sinun mittasi',
      looseEnd: 'väljempi',
      snugEnd: 'istuvampi',
      selectSize: 'Valitse koko {s}',
      disclaimer: 'Suositus perustuu vaatteen ohjeellisiin mittoihin (1–2 cm tarkkuus) ja on suuntaa antava. Se ei ole tae istuvuudesta.',
      loadError: 'Mittataulukkoa ei voitu ladata juuri nyt. Katso mittapiirros koko-oppaasta.',
      required: 'pakollinen'
    },
    en: {
      title: 'Find your size',
      intro: 'Enter your own measurements in centimetres and we will tell you which size fits you best in this product.',
      optional: 'optional',
      submit: 'Find my size',
      recalc: 'Calculate again',
      reset: 'Clear',
      guideShow: 'Show measurement drawing',
      guideHide: 'Hide measurement drawing',
      close: 'Close',
      cm: 'cm',
      needPrimary: 'Please enter at least: {m}.',
      invalid: '{m}: please check the value (10–250 cm).',
      resultTitle: 'We recommend size',
      betweenTitle: 'You are between sizes {a} and {b}',
      betweenText: 'Your measurements fall between two sizes. Choose {a} for a closer fit or {b} for a roomier one.',
      posMiddle: 'sits right in the middle of this size — the fit is exactly as intended.',
      posLoose: 'is at the roomier end of this size.',
      posSnug: 'is at the closer-fitting end of this size.',
      bumped: 'We moved the recommendation up to {s} because {m} does not fit the smaller size.',
      aboveRange: 'Your measurement is larger than the biggest size in the chart, so {s} may feel snug.',
      belowRange: 'Your measurement is smaller than the smallest size in the chart, so {s} will fit loosely.',
      tightWarn: '{m} is tight in this size.',
      infoLong: '{m}: garment {g} cm, you {b} cm — plenty of length.',
      infoShort: '{m}: garment {g} cm, you {b} cm — may run slightly short.',
      infoOk: '{m}: garment {g} cm, you {b} cm — good match.',
      garmentTitle: 'Garment measurements in size {s}',
      yourValue: 'Your measurement',
      looseEnd: 'roomier',
      snugEnd: 'closer fit',
      selectSize: 'Select size {s}',
      disclaimer: 'The recommendation is based on directive garment measurements (1–2 cm tolerance) and is indicative only.',
      loadError: 'The size chart could not be loaded right now. Please see the size guide drawing.',
      required: 'required'
    }
  };

  /* ---------- apufunktiot / helpers ---------- */

  function fmt(str, vars) {
    return String(str).replace(/\{(\w+)\}/g, function (_, k) {
      return vars && vars[k] !== undefined ? vars[k] : '';
    });
  }

  function num(v) {
    var n = parseFloat(String(v).replace(',', '.'));
    return isFinite(n) ? n : null;
  }

  function round1(n) {
    return Math.round(n * 10) / 10;
  }

  function clamp(n, a, b) {
    return Math.min(b, Math.max(a, n));
  }

  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'class') n.className = attrs[k];
        else if (k === 'text') n.textContent = attrs[k];
        else n.setAttribute(k, attrs[k]);
      });
    }
    if (html !== undefined) n.innerHTML = html;
    return n;
  }

  /* ---------- mittalogiikka / measurement maths ---------- */

  // Vaatteen mitta koossa i, vartalomitaksi muunnettuna.
  function garmentAt(m, i) {
    return m.garment[i] * (m.multiplier || 1);
  }

  // Vartalomitta, jolle koko on suunniteltu (tavoiteväljyys).
  function targets(m) {
    return m.garment.map(function (_, i) {
      return garmentAt(m, i) - m.ease.ideal;
    });
  }

  // Kovat rajat: suurin ja pienin vartalomitta, joka kokoon vielä kuuluu.
  function hardMax(m, i) {
    return garmentAt(m, i) - m.ease.min;
  }
  function hardMin(m, i) {
    return garmentAt(m, i) - m.ease.max;
  }

  // Näytettävät kaistat: kunkin koon "oma alue" = puoliväli naapureihin.
  function bands(m) {
    var t = targets(m);
    var n = t.length;
    return t.map(function (v, i) {
      var lo = i === 0 ? v - (t[1] - t[0]) / 2 : (t[i - 1] + v) / 2;
      var hi = i === n - 1 ? v + (t[n - 1] - t[n - 2]) / 2 : (v + t[i + 1]) / 2;
      return { lo: lo, hi: hi, target: v };
    });
  }

  // Jatkuva kokopositio: 0 = pienin koko, n-1 = suurin.
  // below/above = mitta on kokonaan taulukon ulkopuolella (ei vain reunimmaisen koon kohdalla).
  function position(m, body) {
    var t = targets(m);
    var n = t.length;
    var bd = bands(m);
    if (body <= t[0]) return { pos: 0, below: body < bd[0].lo };
    if (body >= t[n - 1]) return { pos: n - 1, above: body > bd[n - 1].hi };
    for (var i = 0; i < n - 1; i++) {
      if (body >= t[i] && body <= t[i + 1]) {
        var frac = (body - t[i]) / (t[i + 1] - t[i]);
        return { pos: i + frac, frac: frac, lower: i, upper: i + 1 };
      }
    }
    return { pos: n - 1 };
  }

  /**
   * Laskee suosituksen.
   * chart: taulukko-objekti, values: { key: cmNumber }
   */
  function recommend(chart, values) {
    var sizes = chart.sizes;
    var used = chart.measurements.filter(function (m) {
      return m.input !== false && values[m.key] != null;
    });

    var primaries = used.filter(function (m) { return m.role === 'primary'; });
    if (!primaries.length) return null;

    // 1) Ensisijaisten mittojen positiot. Käytetään suurinta, jotta mikään ei jää tiukaksi.
    var posInfos = primaries.map(function (m) {
      var p = position(m, values[m.key]);
      p.m = m;
      return p;
    });
    var driver = posInfos.reduce(function (a, b) { return b.pos > a.pos ? b : a; });

    var baseIndex = Math.round(driver.pos);
    var frac = driver.pos - Math.floor(driver.pos);
    var between = null;
    if (!driver.above && !driver.below && frac >= 0.35 && frac <= 0.65) {
      between = [Math.floor(driver.pos), Math.floor(driver.pos) + 1];
      baseIndex = between[0]; // pienempi vaihtoehto oletukseksi
    }

    // 2) Rajoitteet: nostetaan kokoa, kunnes kaikki mitat mahtuvat.
    var notes = [];
    var index = baseIndex;
    var blockers = used.filter(function (m) { return m.role === 'primary' || m.role === 'constraint'; });
    var bumpedBy = null;

    for (var i = index; i < sizes.length; i++) {
      var fits = blockers.every(function (m) { return values[m.key] <= hardMax(m, i); });
      if (fits) { index = i; break; }
      if (i === sizes.length - 1) { index = i; }
    }
    if (index > baseIndex) {
      bumpedBy = blockers.filter(function (m) { return values[m.key] > hardMax(m, baseIndex); })[0];
      if (between) between = null; // rajatapaus raukeaa, jos rajoite pakotti ison koon
    }

    // 3) Huomiot
    if (driver.above) {
      notes.push({ type: 'warn', text: 'aboveRange', vars: { s: sizes[sizes.length - 1] } });
    }
    if (driver.below) {
      notes.push({ type: 'info', text: 'belowRange', vars: { s: sizes[0] } });
    }
    if (bumpedBy) {
      notes.push({ type: 'warn', text: 'bumped', vars: { s: sizes[index], m: bumpedBy.__label } });
    }

    // 4) Mittakohtaiset tulokset
    var rows = used.map(function (m) {
      var b = values[m.key];
      var band = bands(m)[index];
      var p = clamp((b - band.lo) / (band.hi - band.lo), 0, 1);
      var status = 'ok';
      if (b > hardMax(m, index)) status = 'tight';
      else if (b < hardMin(m, index)) status = 'loose';
      return {
        m: m,
        body: b,
        garment: round1(garmentAt(m, index)),
        band: band,
        bands: bands(m),
        p: p,
        status: status,
        ease: round1(garmentAt(m, index) - b)
      };
    });

    var infoOnly = chart.measurements.filter(function (m) {
      return m.role === 'info' && m.input === false;
    }).map(function (m) {
      return { m: m, garment: round1(garmentAt(m, index)) };
    });

    return {
      index: index,
      size: sizes[index],
      activeIndexes: between ? [between[0], between[1]] : [index],
      between: between ? { a: sizes[between[0]], b: sizes[between[1]] } : null,
      rows: rows,
      infoOnly: infoOnly,
      notes: notes,
      driverRow: rows.filter(function (r) { return r.m === driver.m; })[0],
      // Ylittikö mitta suurimman koon: ensisijainen mitta on taulukon yläpuolella,
      // tai jokin mitta ei mahdu edes lopulliseen kokoon (käytännössä suurimpaan,
      // koska nosto jatkuu kunnes kaikki mahtuu tai koot loppuvat).
      aboveRange: !!driver.above || rows.some(function (r) {
        return r.status === 'tight' && (r.m.role === 'primary' || r.m.role === 'constraint');
      }),
      belowRange: !!driver.below
    };
  }

  /**
   * Väljyyden ylikirjoitus tuotetagilla.
   *   ease_30              -> ensisijaisen mitan ihanneväljyys 30 cm (min/max siirtyvät mukana)
   *   ease_chest_30        -> vain rinnan ihanneväljyys
   *   ease_chest_16_30_46  -> min, ihanne, max eksplisiittisesti
   *   ease_waist_-2_2_6    -> negatiiviset arvot sallittuja (kiristävä istuvuus)
   * Useita tageja voi olla rinnakkain; ne käsitellään järjestyksessä.
   */
  function applyEaseTags(chart, tagString) {
    if (!tagString) return [];
    var applied = [];
    String(tagString).split(',').forEach(function (raw) {
      var tag = raw.trim().toLowerCase();
      if (tag.indexOf('ease_') !== 0) return;

      var parts = tag.split('_');
      parts.shift(); // 'ease'
      var key = null;
      var nums = [];
      parts.forEach(function (part) {
        if (part === '') return;
        var n = parseFloat(part.replace(',', '.'));
        if (isFinite(n) && /^-?[\d.,]+$/.test(part)) nums.push(n);
        else if (key === null) key = part;
      });
      if (!nums.length) return;

      var targetsList = key
        ? chart.measurements.filter(function (m) { return m.key === key; })
        : chart.measurements.filter(function (m) { return m.role === 'primary'; });
      if (!targetsList.length) {
        console.warn('[mittis] tagi "' + tag + '": mittaa "' + key + '" ei löydy taulukosta.');
        return;
      }

      targetsList.forEach(function (m) {
        if (!m.ease) return;
        var before = m.ease.min + '/' + m.ease.ideal + '/' + m.ease.max;
        if (nums.length >= 3) {
          m.ease = { min: nums[0], ideal: nums[1], max: nums[2] };
        } else {
          // Yksi luku = ihanneväljyys. Min ja max siirtyvät samalla erotuksella,
          // jolloin koon kaistan leveys säilyy ennallaan.
          var delta = nums[0] - m.ease.ideal;
          m.ease = { min: m.ease.min + delta, ideal: nums[0], max: m.ease.max + delta };
        }
        applied.push(tag + ' -> ' + m.key + ': ' + before + ' => ' +
          m.ease.min + '/' + m.ease.ideal + '/' + m.ease.max);
      });
    });
    return applied;
  }

  /**
   * Joustava materiaali tuotetagilla.
   *   jousto      -> mahtumisraja löystyy oletuksena 6 cm
   *   jousto_10   -> löystyy 10 cm
   * Vaikuttaa vain minimiväljyyteen eli siihen, mahtuuko vaate. Tavoiteväljyys
   * ja siten suunniteltu siluetti säilyvät ennallaan.
   */
  function applyStretchTags(chart, tagString) {
    if (!tagString) return null;
    var amount = null;
    String(tagString).split(',').forEach(function (raw) {
      var tag = raw.trim().toLowerCase();
      if (tag.indexOf('jousto') !== 0) return;
      var rest = tag.slice(6).replace(/^[_-]/, '');
      var n = parseFloat(rest.replace(',', '.'));
      amount = isFinite(n) && n > 0 ? n : 6;
    });
    if (amount === null) return null;

    chart.measurements.forEach(function (m) {
      if (!m.ease || m.input === false) return;
      m.ease.min = Math.round((m.ease.min - amount) * 10) / 10;
    });
    return amount;
  }

  /**
   * Analytiikkatapahtuma, kun asiakas on saanut kokosuosituksen.
   *
   * Tapahtuman nimi: mittis_size_calculated
   *
   * Asiakkaan omia mittoja EI lähetetä — ne ovat henkilötietoa kehosta.
   * Mukana vain johdetut arvot, joista ei voi tunnistaa ketään.
   *
   * Kolme reittiä, koska GA4 voi olla asennettu eri tavoin:
   *   1. gtag suoraan teemassa
   *   2. Google Tag Manager (dataLayer)
   *   3. Shopifyn Google-kanava, jonka pixel on eristetty teeman koodista.
   *      Tällöin tapahtuma julkaistaan Shopifyn väylään ja Custom Pixel
   *      välittää sen eteenpäin (ks. ANALYTIIKKA.md).
   *
   * Jos mitään analytiikkaa ei ole asennettu, funktio ei tee mitään.
   */
  function trackCalculation(widget, result) {
    var payload = {
      chart_key: widget.dataset.chartKey || '',
      recommended_size: result.size,
      is_borderline: result.between ? 'yes' : 'no',
      size_bumped: result.notes.some(function (n) { return n.text === 'bumped'; }) ? 'yes' : 'no',
      above_range: result.aboveRange ? 'yes' : 'no',
      below_range: result.belowRange ? 'yes' : 'no',
      measurements_given: result.rows.length
    };

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'mittis_size_calculated', payload);
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        var dl = {};
        Object.keys(payload).forEach(function (k) { dl[k] = payload[k]; });
        dl.event = 'mittis_size_calculated';
        window.dataLayer.push(dl);
      }

      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('mittis_size_calculated', payload);
      }
    } catch (err) {
      console.warn('[mittis] analytiikkatapahtuman lähetys epäonnistui:', err);
    }
  }

  /**
   * Lyhyt, ihmisen luettava kuvaus suosituksesta tilaukselle.
   *   "M"                      selvä suositus
   *   "S tai M (rajatapaus)"   asiakas osui kahden koon väliin
   *   "L (nostettu: Hauis)"    rajoittava mitta nosti kokoa
   *   "XXL (yli taulukon)"     mitta ylitti suurimman koon
   *   "XS (alle taulukon)"     mitta alitti pienimmän koon
   * Asiakkaan omia mittoja ei tallenneta.
   */
  function describeForOrder(result) {
    var size = result.between ? (result.between.a + ' tai ' + result.between.b) : result.size;
    var flags = [];
    if (result.between) flags.push('rajatapaus');
    var bump = result.notes.filter(function (n) { return n.text === 'bumped'; })[0];
    if (bump && bump.vars && bump.vars.m) flags.push('nostettu: ' + bump.vars.m);
    if (result.aboveRange) flags.push('yli taulukon');
    if (result.belowRange) flags.push('alle taulukon');
    return flags.length ? size + ' (' + flags.join(', ') + ')' : size;
  }

  /**
   * Merkitsee tilaukseen, että Mittistä käytettiin. Kaksi tasoa:
   *
   * 1. Tilausrivin piilotettu ominaisuus  properties[_mittis] = "suositus M"
   *    Lisätään tuotesivun ostoslomakkeisiin. Kulkee sen nimenomaisen tuotteen
   *    mukana, joten palautuksessa näkee suoraan, laskettiinko juuri tämän
   *    tuotteen koko ja mitä suositeltiin. Alaviiva nimen alussa piilottaa sen
   *    asiakkaalta ostoskorissa ja kassalla; adminissa se näkyy tilausrivillä.
   *
   * 2. Ostoskorin attribuutti  Mittis = "11403-800: M; 11703-004: S/M (rajatapaus)"
   *    Varmistus sille, jos teeman ostoskori-JS ei välitä lomakkeen piilokenttiä.
   *    Näkyy tilauksella kohdassa "Lisätiedot" ja tilausviennissä.
   *
   * Molemmat päivittyvät, jos asiakas laskee uudelleen. Virheet eivät koskaan
   * estä suositusta näkymästä.
   */
  function recordOnOrder(widget, result) {
    var key = widget.dataset.chartKey || '';
    var desc = describeForOrder(result);

    // 1) Tilausrivin ominaisuus
    try {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        var input = form.querySelector('input[name="properties[_mittis]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_mittis]';
          form.appendChild(input);
        }
        input.value = 'suositus ' + desc;
      });
    } catch (err) {
      console.warn('[mittis] tilausrivin merkintä epäonnistui:', err);
    }

    // 2) Ostoskorin attribuutti
    if (!key || typeof fetch !== 'function') return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prev = (cart && cart.attributes && cart.attributes.Mittis) || '';
        var entries = String(prev).split(';')
          .map(function (e) { return e.trim(); })
          .filter(function (e) { return e && e.indexOf(key + ':') !== 0; });
        entries.push(key + ': ' + desc);
        entries = entries.slice(-10);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { Mittis: entries.join('; ') } })
        });
      })
      .catch(function (err) {
        console.warn('[mittis] ostoskorin merkintä epäonnistui:', err);
      });
  }

  /* ---------- komponentti / component ---------- */

  var chartCache = {};

  /**
   * Mittataulukot luetaan ensisijaisesti sivulle upotetusta script-elementistä.
   * Näin ei tehdä verkkopyyntöä lainkaan — theme-assetit tarjoillaan
   * cdn.shopify.comista, joka on eri origin kuin kaupan verkkotunnus, eikä
   * cross-origin-fetch ole luotettava.
   *
   * Fetch säilyy varalla, jos snippet mittis-charts.liquid puuttuu.
   */
  function loadCharts(widget) {
    // Puolustava tarkistus: parametrin on oltava widget-elementti, ei URL.
    // Näin virheellinen kutsu palauttaa hylätyn lupauksen eikä heitä
    // poikkeusta synkronisesti, jolloin latausindikaattori jäisi päälle.
    if (!widget || typeof widget.querySelector !== 'function') {
      return Promise.reject(new Error('loadCharts: odotettiin widget-elementtiä, saatiin ' + typeof widget));
    }

    var inline = widget.querySelector('script[data-mittis-charts]');
    if (inline) {
      try {
        var parsed = JSON.parse(inline.textContent);
        return Promise.resolve(parsed);
      } catch (err) {
        console.error('[mittis] snippets/mittis-charts.liquid ei ole validia JSONia:', err);
        return Promise.reject(err);
      }
    }

    var url = widget.dataset.chartsUrl;
    if (!url) return Promise.reject(new Error('mittis-charts puuttuu: ei script-elementtiä eikä data-charts-url -attribuuttia'));
    console.warn('[mittis] script-elementtiä ei löytynyt, haetaan taulukot assetista:', url);
    if (chartCache[url]) return chartCache[url];
    chartCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' — ' + url);
      return r.json();
    });
    return chartCache[url];
  }

  function MittisWidget() {
    return Reflect.construct(HTMLElement, [], MittisWidget);
  }
  MittisWidget.prototype = Object.create(HTMLElement.prototype);
  MittisWidget.prototype.constructor = MittisWidget;
  Object.setPrototypeOf(MittisWidget, HTMLElement);

  MittisWidget.prototype.connectedCallback = function () {
    var self = this;
    this.lang = (this.dataset.lang || 'fi').toLowerCase().indexOf('fi') === 0 ? 'fi' : 'en';
    this.t = I18N[this.lang];
    this.dialog = this.querySelector('dialog');
    this.body = this.querySelector('[data-mittis-body]');
    this.trigger = this.querySelector('[data-mittis-trigger]');
    if (!this.dialog || !this.trigger) return;

    this.trigger.addEventListener('click', function () { self.open(); });
    this.dialog.addEventListener('click', function (e) {
      if (e.target === self.dialog) self.close();
    });
    this.querySelectorAll('[data-mittis-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
  };

  MittisWidget.prototype.open = function () {
    var self = this;
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
    if (!this.chart) {
      this.body.innerHTML = '<p class="mittis__loading">…</p>';
      var pending;
      try {
        pending = loadCharts(this);
      } catch (err) {
        pending = Promise.reject(err);
      }
      pending.then(function (all) {
        var source = all[self.dataset.chartKey] || all[self.dataset.fallbackKey] || null;

        // Alias: "10444-901": "10415-800" osoittaa toiseen taulukkoon.
        // Ketju rajataan, jottei virheellinen alias jää kiertämään.
        var hops = 0;
        while (typeof source === 'string' && hops < 5) {
          source = all[source] || null;
          hops++;
        }

        if (!source) throw new Error('chart not found: ' + self.dataset.chartKey);

        // Syväkopio: välimuistissa oleva taulukko on jaettu, eikä sitä saa muokata.
        var chart = JSON.parse(JSON.stringify(source));

        // Tuotekohtaiset väljyys- ja joustotagit
        var applied = applyEaseTags(chart, self.dataset.ease);
        if (applied.length) console.info('[mittis] väljyys ylikirjoitettu tagilla:', applied);

        var stretch = applyStretchTags(chart, self.dataset.ease);
        if (stretch) console.info('[mittis] joustava materiaali: mahtumisraja löystyy', stretch, 'cm');

        // esilasketaan lokalisoidut nimet
        chart.measurements.forEach(function (m) {
          m.__label = (m.label && (m.label[self.lang] || m.label.fi)) || m.key;
          m.__help = (m.help && (m.help[self.lang] || m.help.fi)) || '';
        });
        self.chart = chart;
        self.renderForm();
      }).catch(function (err) {
        console.error('[mittis] mittataulukon lataus epäonnistui.',
          'avain:', self.dataset.chartKey,
          'vara-avain:', self.dataset.fallbackKey,
          err);
        self.body.innerHTML = '';
        self.body.appendChild(el('p', { class: 'mittis__error', text: self.t.loadError }));
      });
    }
  };

  MittisWidget.prototype.close = function () {
    if (typeof this.dialog.close === 'function') this.dialog.close();
    else this.dialog.removeAttribute('open');
  };

  MittisWidget.prototype.saved = function () {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  };

  MittisWidget.prototype.save = function (values) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(values)); } catch (e) {}
  };

  MittisWidget.prototype.renderForm = function () {
    var self = this, t = this.t, chart = this.chart, prev = this.saved();
    this.body.innerHTML = '';

    this.body.appendChild(el('p', { class: 'mittis__intro', text: t.intro }));

    var form = el('form', { class: 'mittis__form', novalidate: 'novalidate' });
    chart.measurements.forEach(function (m) {
      if (m.input === false) return;
      var id = 'mittis-' + m.key + '-' + Math.random().toString(36).slice(2, 7);
      var field = el('div', { class: 'mittis__field' });
      var label = el('label', { class: 'mittis__label', for: id });
      label.appendChild(el('span', { class: 'mittis__label-text', text: m.__label }));
      label.appendChild(el('span', {
        class: 'mittis__hint',
        text: m.optional ? t.optional : t.required
      }));
      field.appendChild(label);

      var wrap = el('div', { class: 'mittis__input-wrap' });
      var input = el('input', {
        type: 'text',
        inputmode: 'decimal',
        autocomplete: 'off',
        id: id,
        class: 'mittis__input',
        'data-key': m.key,
        placeholder: '0'
      });
      if (prev[m.key] != null) input.value = String(prev[m.key]).replace('.', ',');
      wrap.appendChild(input);
      wrap.appendChild(el('span', { class: 'mittis__unit', text: t.cm }));
      field.appendChild(wrap);
      if (m.__help) field.appendChild(el('p', { class: 'mittis__help', text: m.__help }));
      form.appendChild(field);
    });

    var actions = el('div', { class: 'mittis__actions' });
    var submit = el('button', { type: 'submit', class: 'mittis__submit button', text: t.submit });
    var reset = el('button', { type: 'button', class: 'mittis__reset', text: t.reset });
    actions.appendChild(submit);
    actions.appendChild(reset);
    form.appendChild(actions);

    var errors = el('div', { class: 'mittis__errors', role: 'alert' });
    form.appendChild(errors);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.handleSubmit(form, errors);
    });
    reset.addEventListener('click', function () {
      form.querySelectorAll('input').forEach(function (i) { i.value = ''; });
      self.save({});
      var r = self.body.querySelector('.mittis__result');
      if (r) r.remove();
      errors.innerHTML = '';
    });

    this.body.appendChild(form);
    this.form = form;

    // Mittapiirros (koko-opas metafieldistä)
    var guideUrl = this.dataset.guideImage;
    if (guideUrl) {
      var details = el('details', { class: 'mittis__guide' });
      var summary = el('summary', { text: t.guideShow });
      details.appendChild(summary);
      var img = el('img', { class: 'mittis__guide-img', alt: t.guideShow, loading: 'lazy', src: guideUrl });
      img.addEventListener('error', function () {
        console.error('[mittis] mittapiirroksen lataus epäonnistui:', guideUrl,
          '— tarkista metafield custom.koko_opas.');
        details.remove();
      });
      details.appendChild(img);
      details.addEventListener('toggle', function () {
        summary.textContent = details.open ? t.guideHide : t.guideShow;
      });
      this.body.appendChild(details);
    }

    this.body.appendChild(el('p', { class: 'mittis__disclaimer', text: t.disclaimer }));
  };

  MittisWidget.prototype.handleSubmit = function (form, errors) {
    var t = this.t, chart = this.chart;
    errors.innerHTML = '';
    var values = {}, problems = [];

    chart.measurements.forEach(function (m) {
      if (m.input === false) return;
      var input = form.querySelector('[data-key="' + m.key + '"]');
      if (!input) return;
      var raw = input.value.trim();
      input.classList.remove('is-invalid');
      if (!raw) {
        if (!m.optional && m.role === 'primary') {
          problems.push(fmt(t.needPrimary, { m: m.__label }));
          input.classList.add('is-invalid');
        }
        return;
      }
      var v = num(raw);
      if (v === null || v < 10 || v > 250) {
        problems.push(fmt(t.invalid, { m: m.__label }));
        input.classList.add('is-invalid');
        return;
      }
      values[m.key] = v;
    });

    if (problems.length) {
      problems.forEach(function (p) { errors.appendChild(el('p', { text: p })); });
      return;
    }

    this.save(values);
    var result = recommend(chart, values);
    if (!result) return;
    trackCalculation(this, result);
    recordOnOrder(this, result);
    this.renderResult(result);
  };

  MittisWidget.prototype.renderResult = function (r) {
    var t = this.t, self = this;
    var old = this.body.querySelector('.mittis__result');
    if (old) old.remove();

    var box = el('div', { class: 'mittis__result', tabindex: '-1' });

    // Otsikko
    var head = el('div', { class: 'mittis__result-head' });
    if (r.between) {
      head.appendChild(el('p', { class: 'mittis__result-kicker', text: fmt(t.betweenTitle, r.between) }));
      var pair = el('p', { class: 'mittis__size mittis__size--pair' });
      pair.appendChild(el('span', { class: 'mittis__size-badge', text: r.between.a }));
      pair.appendChild(el('span', { class: 'mittis__size-or', text: '/' }));
      pair.appendChild(el('span', { class: 'mittis__size-badge', text: r.between.b }));
      head.appendChild(pair);
      head.appendChild(el('p', { class: 'mittis__result-text', text: fmt(t.betweenText, r.between) }));
    } else {
      head.appendChild(el('p', { class: 'mittis__result-kicker', text: t.resultTitle }));
      var single = el('p', { class: 'mittis__size' });
      single.appendChild(el('span', { class: 'mittis__size-badge', text: r.size }));
      head.appendChild(single);
      if (r.driverRow) {
        var pos = r.driverRow.p;
        var key = pos < 0.35 ? 'posLoose' : (pos > 0.65 ? 'posSnug' : 'posMiddle');
        head.appendChild(el('p', {
          class: 'mittis__result-text',
          text: r.driverRow.m.__label + ' ' + t[key]
        }));
      }
    }
    box.appendChild(head);

    // Huomiot
    r.notes.forEach(function (n) {
      box.appendChild(el('p', {
        class: 'mittis__note mittis__note--' + n.type,
        text: fmt(t[n.text], n.vars)
      }));
    });

    // Palkit
    r.rows.forEach(function (row) {
      if (row.m.role === 'info') return;
      box.appendChild(self.renderBar(row, r.index, r.activeIndexes));
    });

    // Info-mitat (esim. hihan pituus)
    var infoRows = r.rows.filter(function (row) { return row.m.role === 'info'; });
    if (infoRows.length || r.infoOnly.length) {
      var list = el('ul', { class: 'mittis__info-list' });
      infoRows.forEach(function (row) {
        var d = row.garment - row.body;
        var key = d > (row.m.ease ? row.m.ease.max : 6) ? 'infoLong'
          : (d < (row.m.ease ? row.m.ease.min : -2) ? 'infoShort' : 'infoOk');
        list.appendChild(el('li', {
          text: fmt(t[key], { m: row.m.__label, g: row.garment, b: round1(row.body) })
        }));
      });
      r.infoOnly.forEach(function (row) {
        list.appendChild(el('li', { text: row.m.__label + ': ' + row.garment + ' cm' }));
      });
      var wrap = el('div', { class: 'mittis__info' });
      wrap.appendChild(el('h4', { text: fmt(t.garmentTitle, { s: r.size }) }));
      wrap.appendChild(list);
      box.appendChild(wrap);
    }

    // Valitse koko -painike
    if (this.dataset.selectVariant === 'true') {
      var sizesToOffer = r.between ? [r.between.a, r.between.b] : [r.size];
      var btnRow = el('div', { class: 'mittis__select-row' });
      sizesToOffer.forEach(function (s) {
        var btn = el('button', { type: 'button', class: 'mittis__select button', text: fmt(t.selectSize, { s: s }) });
        btn.addEventListener('click', function () {
          if (self.selectSize(s)) self.close();
        });
        btnRow.appendChild(btn);
      });
      box.appendChild(btnRow);
    }

    this.form.after(box);
    box.focus();
    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  /** Palkki: kaikki koot skaalalla, aktiivinen korostettuna, pystyviiva = asiakkaan mitta. */
  MittisWidget.prototype.renderBar = function (row, index, activeIndexes) {
    var active = activeIndexes || [index];
    var t = this.t;
    var bs = row.bands;
    var lo = bs[0].lo, hi = bs[bs.length - 1].hi;
    var span = hi - lo;
    var pct = function (v) { return ((v - lo) / span) * 100; };

    var wrap = el('div', { class: 'mittis__bar' });

    var top = el('div', { class: 'mittis__bar-head' });
    top.appendChild(el('span', { class: 'mittis__bar-title', text: row.m.__label }));
    top.appendChild(el('span', {
      class: 'mittis__bar-value',
      text: round1(row.body) + ' ' + t.cm
    }));
    wrap.appendChild(top);

    var track = el('div', { class: 'mittis__track' });
    var sizes = this.chart.sizes;
    bs.forEach(function (b, i) {
      var seg = el('div', {
        class: 'mittis__seg' + (active.indexOf(i) > -1 ? ' is-active' : ''),
        style: 'left:' + pct(b.lo) + '%;width:' + (pct(b.hi) - pct(b.lo)) + '%'
      });
      seg.appendChild(el('span', { class: 'mittis__seg-label', text: sizes[i] }));
      track.appendChild(seg);
    });

    var markerPos = clamp(pct(row.body), 0, 100);
    var marker = el('div', {
      class: 'mittis__marker' + (row.status !== 'ok' ? ' is-warn' : ''),
      style: 'left:' + markerPos + '%',
      title: t.yourValue + ': ' + round1(row.body) + ' cm'
    });
    marker.appendChild(el('span', { class: 'mittis__marker-flag', text: t.yourValue }));
    track.appendChild(marker);
    wrap.appendChild(track);

    var foot = el('div', { class: 'mittis__bar-foot' });
    foot.appendChild(el('span', { text: t.looseEnd }));
    foot.appendChild(el('span', {
      class: 'mittis__bar-ease',
      text: '+' + round1(row.ease) + ' ' + t.cm
    }));
    foot.appendChild(el('span', { text: t.snugEnd }));
    wrap.appendChild(foot);

    if (row.status === 'tight') {
      wrap.appendChild(el('p', {
        class: 'mittis__note mittis__note--warn',
        text: fmt(t.tightWarn, { m: row.m.__label })
      }));
    }
    return wrap;
  };

  /** Yrittää valita koon teeman variantinvalitsimesta. Palauttaa true jos onnistui. */
  MittisWidget.prototype.selectSize = function (size) {
    var form = document.querySelector('form[action*="/cart/add"]') || document;
    var norm = function (s) { return String(s).trim().toLowerCase(); };
    var found = false;

    form.querySelectorAll('select').forEach(function (sel) {
      if (found) return;
      Array.prototype.forEach.call(sel.options, function (opt) {
        if (!found && norm(opt.value) === norm(size)) {
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          found = true;
        }
      });
    });

    if (!found) {
      form.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        if (found) return;
        if (norm(inp.value) === norm(size)) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
          inp.dispatchEvent(new Event('click', { bubbles: true }));
          found = true;
        }
      });
    }

    if (!found) {
      form.querySelectorAll('label').forEach(function (lab) {
        if (found) return;
        if (norm(lab.textContent) === norm(size)) {
          lab.click();
          found = true;
        }
      });
    }
    return found;
  };

  if (!window.customElements.get('mittis-widget')) {
    window.customElements.define('mittis-widget', MittisWidget);
  }

  // Testattavuus
  window.Mittis = { describeForOrder: describeForOrder, recommend: recommend, bands: bands, targets: targets, applyEaseTags: applyEaseTags };
})();
